import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Footer } from "@/components/landing/Footer";
import { API } from "@/lib/api";

const TITLES = {
  privacy: "Privacy Policy",
  terms: "Terms of Service",
  cookies: "Cookie Policy",
  "data-deletion": "Data Deletion",
  "acceptable-use": "Acceptable Use",
};

function applyTokens(md, legal = {}) {
  return md.replace(/\{\{([A-Z_]+)\}\}/g, (m, key) =>
    legal[key] != null && legal[key] !== "" ? legal[key] : m
  );
}

export default function LegalPage() {
  const { slug } = useParams();
  const key = TITLES[slug] ? slug : "privacy";
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    setLoading(true);
    Promise.all([
      fetch(`/legal/${key}.md`).then((r) => (r.ok ? r.text() : Promise.reject())),
      axios.get(`${API}/settings`).then((r) => r.data.legal).catch(() => ({})),
    ])
      .then(([md, legal]) => setContent(applyTokens(md, legal)))
      .catch(() => setContent("# Not found\n\nThis document could not be loaded."))
      .finally(() => setLoading(false));
  }, [key]);

  return (
    <div className="min-h-screen bg-bone flex flex-col" data-testid="legal-page">
      <div className="flex-1">
        <div className="mx-auto max-w-3xl px-5 sm:px-8 pt-28 md:pt-36 pb-24">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-ink/60 hover:text-coral transition-colors mb-12"
            data-testid="legal-back"
          >
            <ArrowLeft className="w-4 h-4" /> Back to Chateaux
          </Link>
          <p className="text-xs uppercase tracking-[0.2em] text-coral mb-4">Legal</p>
          {loading ? (
            <p className="text-ink/50">Loading…</p>
          ) : (
            <article className="legal-prose" data-testid="legal-content">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
            </article>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
